import { httpRequest } from "@/utils/HttpRequest";
import {ITakeMealDetial,ITakeMealFields,ITakeMealInsert,ITakeMealUpdate} from "./takeMealTypes"

class TakeMealService {
    async findByMeal(searchVo: ITakeMealFields) {
        const apiUrl = "/common/menu/findByMeal";
        return await httpRequest.post<ITakeMealDetial[]>(apiUrl, searchVo);
    }
    async insert(searchVo: ITakeMealInsert) {
        const apiUrl = "/common/menu/insert";
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }
    async update(searchVo: ITakeMealUpdate) {
        const apiUrl = "/common/menu/update";
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }
}
export const takeMealService = new TakeMealService();
